import '@shopify/admin-api-client';
import 'compare-versions';
import '../types.mjs';
import '../../runtime/crypto/crypto.mjs';
import '../../runtime/crypto/types.mjs';
import '@shopify/network';

/* eslint-disable @shopify/typescript/prefer-pascal-case-enums */
var DataType;
(function (DataType) {
    DataType["JSON"] = "application/json";
    DataType["GraphQL"] = "application/graphql";
    DataType["URLEncoded"] = "application/x-www-form-urlencoded";
})(DataType || (DataType = {}));

export { DataType };
//# sourceMappingURL=types.mjs.map
